/**
 * Волна A (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/about'>.
 * CacheDataRoute переиспользуется как shell (SEO/meta.ready, Layout,
 * CookieWarning) — после codemod он целиком на @compat/router и работает
 * вне RR-контекста. Сужение: легаси-роут был не-exact (матчил /about/мусор) —
 * теперь такие URL уходят в 404, осознанно.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import About from '@routes/StaticPages/About';

export const Route = createFileRoute('/about')({
  component: () => <CacheDataRoute component={About} path='/about' />
});
